import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { PageLoader } from "@/components/shared";
import { PreviewContent } from "@/components/PreviewContent";
import { ArrowLeft, Eye } from "lucide-react";

export default function PreviewClient() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data, isLoading } = useQuery({
    queryKey: ["client-preview", id],
    queryFn: async () => (await api.get(`/agent/clients/${id}/preview`)).data,
  });

  if (isLoading) return <div className="min-h-screen bg-background"><PageLoader /></div>;

  return (
    <div className="min-h-screen bg-background">
      <div className="sticky top-0 z-30 bg-primary text-primary-foreground" data-testid="preview-banner">
        <div className="max-w-5xl mx-auto px-4 py-3 flex items-center gap-3">
          <Eye className="h-4 w-4 shrink-0" />
          <p className="text-sm font-medium flex-1">
            Preview mode — this is exactly what <strong>{data.client.name}</strong> sees. Read-only; agent-only notes are hidden.
          </p>
          <Button size="sm" variant="secondary" className="rounded-full gap-1 h-8" onClick={() => navigate(`/agent/clients/${id}`)} data-testid="exit-preview-btn">
            <ArrowLeft className="h-3.5 w-3.5" /> Exit preview
          </Button>
        </div>
      </div>
      <main className="max-w-5xl mx-auto p-4 sm:p-8 space-y-8">
        <PreviewContent data={data} />
      </main>
    </div>
  );
}
